var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFixIntermediate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4425_7889)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1366 9.38672L10.2697 9.14824L9.63486 9.7831L4.35938 15.0618L2.93818 13.6406L8.21367 8.36514L8.84854 7.73027L8.61328 6.86338C8.52949 6.56045 8.48438 6.24141 8.48438 5.90625C8.48438 3.95654 10.0312 2.36455 11.9648 2.3001L10.998 3.26689L10.5469 3.71807V4.35938V5.90625V7.45312H12.0938H13.6406H14.2819L14.7363 6.99873L15.7031 6.03193C15.6354 7.96553 14.0467 9.5124 12.097 9.5124C11.765 9.5124 11.4428 9.46729 11.1398 9.3835L11.1366 9.38672ZM4.35938 17.25L5.45186 16.1575L10.7306 10.8788C11.1656 10.998 11.6232 11.0625 12.0938 11.0625C14.9426 11.0625 17.25 8.75508 17.25 5.90625C17.25 5.47119 17.1952 5.0458 17.0921 4.63975C16.9535 4.09189 16.7279 3.57627 16.4282 3.11543L15.2971 4.24658L13.6406 5.90625H12.0938V4.35938L13.7534 2.69971L14.8846 1.56855C14.4205 1.26885 13.9081 1.04326 13.3603 0.904688C12.9542 0.804785 12.5288 0.75 12.0938 0.75C9.24492 0.75 6.9375 3.05742 6.9375 5.90625C6.9375 6.37998 7.00195 6.8376 7.12119 7.26943L1.84248 12.5481L0.75 13.6406L1.84248 14.7331L3.26367 16.1543L4.35938 17.25ZM4.61719 14.1111L5.34551 13.3828L4.61719 12.6545L3.88887 13.3828L4.61719 14.1111Z",
    fill: "#F7C631"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4425_7889"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFixIntermediate);
export default __webpack_public_path__ + "static/media/FixIntermediate.cbd3caa82269b75aa44c7c13146cb0aa.svg";
export { ForwardRef as ReactComponent };